import { Fragment } from "react";
import styles from "../AddressBook.module.css";

type StepStatus = "complete" | "active" | "pending";

type WizardStepperProps = {
  steps: Array<{ label: string; status: StepStatus }>;
};

export function WizardStepper({ steps }: WizardStepperProps) {
  return (
    <div className={styles.wizardStepper}>
      {steps.map((step, i) => (
        <Fragment key={step.label}>
          {i > 0 && (
            <div
              className={`${styles.wizardStepConnector} ${
                step.status === "complete" || step.status === "active"
                  ? styles.wizardStepConnectorComplete
                  : ""
              }`}
            />
          )}
          <div className={styles.wizardStep}>
            <div
              className={`${styles.wizardStepCircle} ${
                step.status === "active" ? styles.wizardStepCircleActive : ""
              } ${step.status === "complete" ? styles.wizardStepCircleComplete : ""}`}
            >
              {step.status === "complete" ? "✓" : i + 1}
            </div>
            <span
              className={`${styles.wizardStepLabel} ${
                step.status === "active" ? styles.wizardStepLabelActive : ""
              }`}
            >
              {step.label}
            </span>
          </div>
        </Fragment>
      ))}
    </div>
  );
}
